import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SchedulingService } from '../../scheduling.service';
import { PatientSearchModel } from '../../../../models/patient/patient-search.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { PatientHaltDialogComponent } from '../../../../dialog/patient-halt-dialog/patient-halt-dialog.component';
import { PatientService } from '../../../patient/patient.service';
import { PatientDataModel } from '../../../../models/patient/patient-data.model';
import { ContactCommsDataModel } from '../../../../models/person/contact-comms-data.model';
import { PatientDialogDataModel } from '../../../patient/patient-dialog-data.model';
import { PatientEditComponent } from '../../../patient/patient-edit/patient-edit.component';
import { AppointmentDialogDataModel } from '../../models/appointment-dialog-data.model';
import { DoctorDataModel } from '../../../../models/doctors/doctor-data.model';
import { ToothUiManagerModel } from '../../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { DialogService } from '../../../../services/dialog.service';
import { StaticDataService } from '../../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { TdoDropdownChange } from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { AppointmentDetailDataModel } from '../../../../models/appointments/appointment-detail-data.model';
import {
    AppointmentProcedureDialogComponent
} from '../appointment-procedure-dialog/appointment-procedure-dialog.component';
import { DoctorsService } from '../../../../services/doctors.service';
import { DoctorQueryOptionsModel } from '../../../../models/doctors/doctor-query-options.model';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { OperatoryDataModel } from '../../../../models/clients/operatory-data.model';
import { TdoSimpleNoteComponent } from '../../../../tdo-controls/common/tdo-simple-note/tdo-simple-note.component';
import { DataAppointmentModel } from '../../../../models/appointments/data-appointment.model';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { CommMethodEnum } from '../../../../models/enum/comm-method.enum';
import { FileManagerService } from '../../../file-manager/file-manager.service';
import { TdoUserConfigurationModel } from '../../../../models/configuration/user/tdo-user-configuration.model';
import { FlagsService } from '../../../../services/flags.service';
import { Globals } from '../../../../globals';
import { PatientFlagDataModel } from '../../../../models/patient/patient-flag-data.model';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { AppointmentOperatoryDataModel } from '../../../../models/appointments/appointment-operatory-data.model';
import { formatDate } from '@angular/common';
import { NextApptWhenEnum } from 'src/app/models/enum/notification/next-appt-when.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralDataModel } from '../../../configuration/referral-configuration/models/referral-data.model';
import { EnumReferralStatus } from '../../../../models/enum/enum-referral-status';
import { ReferralsService } from '../../../configuration/referral-configuration/referrals.service';
import { ApptTypeEnum } from '../../../../models/enum/appt-type.enum';
import { ApptStatusEnum } from '../../../../models/enum/appt-status.enum';
import { MessagingService } from 'src/app/services/messaging.service';
import { NotesService } from 'src/app/services/notes.service';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import {
    TdoNoteAssociatedObject,
    TdoNoteSaveModel
} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { DataAppointmentWaitListModel } from "../../../../models/appointments/dataAppointmentWaitList.model";
import { DoctorTypeEnum } from 'src/app/models/enum/doctor-type.enum';


@Component({
  standalone: false,
    selector: 'app-appointment-dialog',
    templateUrl: './appointment-dialog.component.html',
    styleUrls: ['./appointment-dialog.component.scss']
})
export class AppointmentDialogComponent implements OnInit, AfterViewInit {
    @ViewChild('appointmentTable') appointmentTable: TdoTableV2Component;
    @ViewChild('simpleNote') simpleNote: TdoSimpleNoteComponent;
    @ViewChild('addToCallListCheck') addToCallListCheck: MatCheckbox;
    @ViewChild('patientCallCheck') patientCallCheck: MatCheckbox;



    @ViewChild('willCallDateTime') willCallDateTime: HTMLInputElement;

    NextApptWhenEnum = NextApptWhenEnum;
    searchForPatientSubscription: any = false;
    SearchFor: any;
    patient: PatientDataModel;
    doctorPredicate: (data: DoctorDataModel) => string;
    userPredicate: (data: TdoUserConfigurationModel) => string;
    referringDoctorPredicate: (data: DoctorDataModel) => string;

    enumApptTypes: EnumValidValueItemModel[];
    toothSurfaceEnums: EnumValidValueItemModel[] = [];
    procedureTypeEnums: EnumValidValueItemModel[] = [];

    /** Statuses that are retired and must not be offered in the Status dropdown. */
    readonly excludedApptStatusIds: string[] = [ApptStatusEnum.Created];
    patientFlagEnums: EnumValidValueItemModel[];

    locationDoctors: DoctorDataModel[] = [];
    doctors: DoctorDataModel[] = [];
    isAllDoctors: boolean = false;

    currentDateAndTime: Date;
    minEndDateAndTime: Date;
    maxStartDateAndTime: Date;
    patientAppointments: DataAppointmentModel[] = [];
    patientPictureSrc: string = 'assets/Images/defaultPatient.PNG';
    isOverrideSms: boolean = false;
    isCustomSmsMessage: boolean = false;
    customSmsMessage: string = '';
    isLoading = false;
    isAppointmentCanceled = false;
    isAppointmentConfirmation = false;
    originalStartDate: string = '';
    isReferralRequest: boolean = false;
    referralNote: TdoNoteSaveModel;
    isWaitList: boolean = false;
    WaitListReason: string = '';
    isReadOnlyAppointment: boolean = false;

    constructor(
        private readonly schedulingService: SchedulingService,
        private readonly flagService: FlagsService,
        private readonly fileService: FileManagerService,
        private readonly patientService: PatientService,
        private readonly dialogService: DialogService,
        private readonly staticDataService: StaticDataService,
        private readonly doctorsService: DoctorsService,
        private readonly localStorageService: LocalStorageService,
        private globals: Globals,
        @Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataModel,
        private readonly dialogRef: MatDialogRef<AppointmentDialogComponent>,
        private readonly dialog: MatDialog,
        private readonly snackBar: MatSnackBar,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly referralService: ReferralsService,
        private readonly messagingService: MessagingService,
        private readonly notesService: NotesService) { }

    ngOnInit(): void {
        this.doCheckCustomSms();
        this.doCheckEarlierAppReason();
        this.isAppointmentCanceled = this.data.cancellingAppointment;

        if (this.isAppointmentCanceled === true) {
            this.isReadOnlyAppointment = false;

            this.data.appointment.enumApptStatusId = ApptStatusEnum.Canceled;
        }
        else {
            this.isReadOnlyAppointment = this.data.isReadOnly;
        }
        this.isAppointmentConfirmation = this.data.confirmingAppointment;
        if ((this.isReadOnlyAppointment || this.isAppointmentConfirmation) && !this.isAppointmentCanceled) {
            this.isAppointmentCanceled = true;
        }

        this.data.appointment.enumApptStatusId ??= ApptStatusEnum.Unconfirmed;

        this.originalStartDate = this.data.appointment.StartDate;
        if (!this.data.appointment.xauditCreatedBy) {
            this.data.appointment.xauditCreatedBy = this.localStorageService.currentUserData.authdata.userid;
        }

        if (!this.data.appointment.xauditModifiedBy) {
            this.data.appointment.xauditModifiedBy = this.localStorageService.currentUserData.authdata.userid;
        }

        if (this.data.appointment.PatientId) {
            this.loadPatient(this.data.appointment.PatientId);
        }
        this.referringDoctorPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName + ', ' + data.dataContact.FirstName + (data.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001' ? '  (TDO)' : '  (REF)');

        this.doctorPredicate = (data) => 'Dr. ' + data.dataContact.LastName;

        this.userPredicate = (data) => data.FirstName + ' ' + data.LastName;

        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupValidValues();
                }
            });
        } else {
            this.setupValidValues();
        }

        if (this.globals.ReferralAppointmentRequest && this.data.appointment.PatientId === null) {
            this.dialogService.openConfirmDialog('Create Appointment based on Referral Request ?').subscribe((result) => {
                if (result === true) {
                    this.loadReferralInformation();
                } else {
                    this.isReferralRequest = false;
                }

            });
        }

    }

    loadReferralInformation() {
        this.isReferralRequest = true;
        this.loadPatient(this.globals.ReferralAppointmentRequest.PatientID);
        // Add Referral Doc info
        const ReferralDocIdDetail1 = new AppointmentDetailDataModel();
        ReferralDocIdDetail1.DetailParameterName = 'Referring_DoctorId';
        ReferralDocIdDetail1.DetailParameterValue = this.globals.ReferralAppointmentRequest.ReferralDoctorID;
        ReferralDocIdDetail1.AppointmentId = this.data.appointment.AppointmentId;
        this.data.appointment.dataAppoitmentDetails.push(ReferralDocIdDetail1);
        // Select Provider Doc from Referral
        this.data.appointment.Label_DoctorId = this.globals.ReferralAppointmentRequest.ProviderId;
        // select Teeth
        const teeth = this.globals.ReferralAppointmentRequest.Teeth;
        // Split the string into an array of values
        const teethValues = teeth.split(',');
        const modifiedValues = teethValues.map(value => `#${value.trim()}`);
        this.data.appointment.Subject = modifiedValues.join(' ; ');
        // adding notes
        this.data.appointment.Description = this.globals.ReferralAppointmentRequest.AppNotes;
        this.simpleNote.note.Note = this.globals.ReferralAppointmentRequest.Notes;
        this.referralNote = new TdoNoteSaveModel();
        this.referralNote.text = this.globals.ReferralAppointmentRequest.ReferralNotes;
    }

    loadPatient(PatientId: string) {
        this.isLoading = true;
        this.patientService.getPatient(PatientId).subscribe((userRes) => {

            const doctorQueryModel = new DoctorQueryOptionsModel();
            doctorQueryModel.isLazyLoad = false;
            doctorQueryModel.isIncludeTdo = true;
            doctorQueryModel.isIncludeReferring = true;
            doctorQueryModel.PatientId = PatientId;
            // this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
            //     // this.allDocsList = allDoctors;
            //     this.data.allDoctors = allDoctors;
            // });


            this.isLoading = false;
            this.fileService.getPatientPicture(PatientId).subscribe((res) => {
                if (res) {
                    this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
                } else {
                    this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
                }
            });
            if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                const config = new MatDialogConfig();
                config.data = userRes.ThePatient;
                config.panelClass = 'dialog';

                this.dialog.open(PatientHaltDialogComponent, config).afterClosed().subscribe((res) => {
                    if (res) {
                        this.loadSelectedPatient(userRes.ThePatient, null);
                    }
                });
            } else {
                this.loadSelectedPatient(userRes.ThePatient, null);
            }
        });

        this.patientAppointments = [];
        this.schedulingService.getAllPatientAppointments(PatientId).subscribe((res) => {
            this.patientAppointments = res;
            this.appointmentTable.updateData(this.patientAppointments);
        });
    }

    private setupValidValues(): void {
        this.enumApptTypes = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
        this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
        this.procedureTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProcedureType');
        this.patientFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumPatientFlag');

        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isActiveOnly = true;
        doctorQueryModel.isIncludeReferring = false;
        doctorQueryModel.LOCID = parseInt(this.data.currentLocationId);
        this.doctorsService.getDoctorsForDoctorLocationV2(doctorQueryModel).subscribe((locationDoctors) => {
            // provider doctors
            this.locationDoctors = locationDoctors;
            this.doctors = locationDoctors;
        });
    }

    ngAfterViewInit(): void {
        // console.log("ngAfterViewInit");
    }

    onPatientSearchSelectionChanged(e) {
        const user = e;



        /* if (e.selectedRowsData.length === 0) {
          return;
        }*/
        if (!user) {
            return;
        }

        console.log('Selection made ', e);


        this.data.appointment.PatientId = user.PatientId;
        if (this.data.appointment.PatientId) {
            this.patientService.getPatient(this.data.appointment.PatientId).subscribe((userRes) => {


                this.fileService.getPatientPicture(this.data.appointment.PatientId).subscribe((res) => {
                    if (res) {
                        this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
                    } else {
                        this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
                    }
                });
                if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                    const config = new MatDialogConfig();
                    config.data = userRes.ThePatient;
                    config.panelClass = 'dialog';

                    this.dialog.open(PatientHaltDialogComponent, config).afterClosed().subscribe((res) => {
                        if (res) {
                            this.loadSelectedPatient(userRes.ThePatient, null);
                        }
                    });
                } else {
                    this.loadSelectedPatient(userRes.ThePatient, null);
                }
            });

            this.patientAppointments = [];
            this.schedulingService.getAllPatientAppointments(this.data.appointment.PatientId).subscribe((res) => {
                this.patientAppointments = res;
                this.appointmentTable.updateData(this.patientAppointments);
            });
        }
    }

    loadSelectedPatient(patient: PatientDataModel, user: PatientSearchModel) {
        console.log('loadSelectedPatient');
        this.patient = patient;
        this.data.appointment.PatientId = this.patient.PatientId;
        this.data.appointment.dataAppoitmentDetails = [];
        this.isWaitList = false;
        this.isOverrideSms = false;
        this.changeDetectorRef.detectChanges();

        /// Disable automatic selection of communications. COMMS template will replace this functionality.
        // Only auto-enable a channel for preferred methods the patient has NOT opted out of.
        // const preferred = this.patient.dataContact.dataContactComms.filter(p => ContactCommsDataModel.isAutoSendEligible(p));
        // for (const pref of preferred) {
        //     switch (pref.enumCommMethodID) {
        //         case '00000009-1000-0000-0000-000000000004':
        //             // EMAIL
        //             let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendEmail');
        //             if (detail) {
        //                 detail.DetailParameterValue = 'true';
        //             } else {
        //                 detail = new AppointmentDetailDataModel();
        //                 detail.DetailParameterName = 'sendEmail';
        //                 detail.DetailParameterValue = 'true';
        //                 detail.AppointmentId = this.data.appointment.AppointmentId;

        //                 this.data.appointment.dataAppoitmentDetails.push(detail);
        //             }


        //             this.changeDetectorRef.detectChanges();


        //             break;
        //         case '00000009-1000-0000-0000-000000000003':
        //             // MOBILE
        //             let detail1 = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendSMS');
        //             if (detail1) {
        //                 detail1.DetailParameterValue = 'true';
        //             } else {
        //                 detail1 = new AppointmentDetailDataModel();
        //                 detail1.DetailParameterName = 'sendSMS';
        //                 detail1.DetailParameterValue = 'true';
        //                 detail1.AppointmentId = this.data.appointment.AppointmentId;
        //                 this.data.appointment.dataAppoitmentDetails.push(detail1);
        //             }

        //             this.changeDetectorRef.detectChanges();

        //             break;
        //     }
        // }

        if (user) {
            this.data.appointment.PatientId = user.PatientId;
        }


        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isIncludeTdo = true;
        doctorQueryModel.isIncludeReferring = true;
        doctorQueryModel.PatientId = this.data.appointment.PatientId;
        this.doctorsService.getDoctorsSummary(doctorQueryModel).subscribe((allDoctors) => {

            this.data.allDoctors = allDoctors as any;
            let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');

            if (detail == null) {
                this.patientService.getPatientReferringDoctor(this.data.appointment.PatientId).subscribe((res) => {
                    if (res && res.DoctorId && this.data.appointment) {
                        if (detail) {
                            detail.DetailParameterValue = res.DoctorId;
                        } else {
                            detail = new AppointmentDetailDataModel();
                            detail.DetailParameterName = 'Referring_DoctorId';
                            detail.DetailParameterValue = res.DoctorId;
                            detail.AppointmentId = this.data.appointment.AppointmentId;
                            if (this.data.appointment.dataAppoitmentDetails) {
                                this.data.appointment.dataAppoitmentDetails = [];
                            }
                            this.data.appointment.dataAppoitmentDetails.push(detail);
                        }
                    }
                });
            }
        });

        let patientInfo = '';
        patientInfo = '{\'FirstName\': \'' + this.patient.dataContact.FirstName + '\', \'LastName\': \'' + this.patient.dataContact.LastName + '\' }';

        this.data.appointment.PatientFullInfo = patientInfo;


        this.SearchFor = null;

    }

    onNewPatientClick() {
        console.log('onNewPatientClick');
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
        dm.title = 'New Patient';
        //dm.initWebId = true;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '600px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        console.log('onNewPatientClick PatientEditComponent');
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            console.log('onNewPatientClick PatientEditComponent afterClosed');
            if (!result) {
                return;
            }

            this.patientService.getPatient(result.ThePatient.PatientId).subscribe((userRes) => {
                if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                    const config1 = new MatDialogConfig();
                    config1.data = userRes.ThePatient;
                    config1.panelClass = 'dialog';

                    this.dialog.open(PatientHaltDialogComponent, config1).afterClosed().subscribe((res) => {
                        if (res) {
                            this.loadSelectedPatient(userRes.ThePatient, null);
                        }
                    });
                } else {
                    console.log('onNewPatientClick loadSelectedPatient');
                    this.loadSelectedPatient(userRes.ThePatient, null);
                }
            });

        }, err => {
        });
    }

    launchPatientDetails() {
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
        dm.title = 'Edit Patient';
        //dm.initWebId = true;
        dm.entityId = this.patient.PatientId;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '600px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.patientDeleted) {
                    // Patient was deleted, close the appointment dialog
                    this.dialogRef.close({ patientDeleted: true });
                    return;
                }
                
                const patientInfo = JSON.parse(this.data.appointment.PatientFullInfo);
                patientInfo.FullName = `${result.ThePatient.dataContact.FirstName} ${result.ThePatient.dataContact.LastName}`;
                this.data.appointment.PatientFullInfo = JSON.stringify(patientInfo);
            }
        }, err => {
            // console.log(err);
        });
    }

    displayFn(patient: any): string {
        if (patient && patient.FirstName && patient.LastName) {
            return patient.FirstName + ' ' + patient.LastName;
        }

        return '';
    }

    selectAppointmentTooth() {
        this.dialogService.openToothPicker(true).subscribe((res: ToothUiManagerModel[]) => {
            //
            const selectedTeeth = [];
            this.data.appointment.Subject = '';
            let i = 0;
            for (const t of res) {
                selectedTeeth.push(t);
                if (i > 0) {
                    this.data.appointment.Subject += ' ; ';
                }
                this.data.appointment.Subject += '#' + t.toothModel.cfgToothDescriptions[0].Notation;
                if (t.selectedSurfaceIds && t.selectedSurfaceIds.length > 0) {
                    this.data.appointment.Subject += ' (';
                    let id = 0;
                    for (const s of t.selectedSurfaceIds) {
                        if (id > 0) {
                            this.data.appointment.Subject += ',';
                        }
                        this.data.appointment.Subject += this.toothSurfaceEnums.find(p => p.ValidValueItemId.toLowerCase() === s.toLowerCase()).ItemSValue;
                        id++;
                    }
                    this.data.appointment.Subject += ')';
                }
                i++;
            }
            
            this.changeDetectorRef.detectChanges();
        });
    }

    returnDoctorById(doctorId: string): DoctorDataModel {
        if (!this.data.allDoctors) {
            return;
        }
        const foundDoctor = this.data.allDoctors.find(doctor => doctorId === doctor?.DoctorId);

        if (foundDoctor) {
            return foundDoctor;
        }
    }

    getReferringDoctor() {
        if (!this.patient) {
            return;
        }
        const details = this.data.appointment.dataAppoitmentDetails;
        if (!details) {
            this.data.appointment.dataAppoitmentDetails = [];
        }
        if (details) {
            const detail = details.find(p => p.DetailParameterName === 'Referring_DoctorId');
            if (detail) {
                const foundDoctor = this.data.allDoctors.find(doctor => doctor?.DoctorId?.toLowerCase() === detail.DetailParameterValue);
                if (foundDoctor) {
                    // this.triggerChangeDetection();
                    return foundDoctor;
                }
            } else {
                const ref1 = this.patient.dataPatientDoctors.find(p => p.isReferring);
                if (ref1) {
                    const ref = new AppointmentDetailDataModel();
                    ref.DetailParameterName = 'Referring_DoctorId';
                    ref.DetailParameterValue = ref1.DoctorID;
                    ref.AppointmentId = this.data.appointment.AppointmentId;
                    this.data.appointment.dataAppoitmentDetails.push(ref);

                    return this.data.allDoctors.find(p => p.DoctorId.toLowerCase() === ref1.DoctorID.toLowerCase());
                }
            }
            return null;
        }
    }

    async onOkClick() {
        console.log('onOkClick');
        this.isLoading = true;
        // if block appt
        console.log('onOkClick isReadOnlyAppointment', this.isReadOnlyAppointment);
        if (this.isReadOnlyAppointment) {
            this.isLoading = false;
            this.dialogRef.close(false);
            return;
        }
        if (this.showBlockAppt()) {
            this.data.appointment.PatientId = null;
            this.data.appointment.CaseProcedureId = null;
            this.data.appointment.isExistingCase = false;
            this.data.appointment.PatientCaseId = null;
            this.data.appointment.CaseWorkItemId = null;
            this.data.appointment.enumApptStatusId = ApptStatusEnum.Unconfirmed;
        }

        // patient full info string
        const detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendSMS') && !this.isOverrideSms;
        if (detail) {
            this.generateSMSMessage();
        }
        if (this.isAppointmentConfirmation) {
            this.data.appointment.enumApptStatusId = ApptStatusEnum.Confirmed
        }

        localStorage.setItem('isSelectedMTI', 'false');
        console.log('onOkClick saveAppointment', this.data.appointment);
        
        this.schedulingService.saveAppointment(this.data.appointment).subscribe((res) => {

            if (!this.showBlockAppt()) {
                void this.handleAppointmentFlags(res);
                void (this.isReferralRequest ? this.handleReferralRequest(res) : Promise.resolve());
                void (this.isWaitList ? this.handleWaitList(res) : Promise.resolve());
                void this.handleAppointmentNote(res);
            } else {
                this.isLoading = false;
                this.dialogRef.close(res);
            }

        }, (error) => {
            this.isLoading = false;
            this.snackBar.open('Error Saving Appointment Data: ' + error.error.ExceptionMessage, 'Error', {
                duration: 10000,
                verticalPosition: 'top'
            });

        });
    }

    async handleAppointmentFlags(res: DataAppointmentModel) {
        const appointmentId = res.AppointmentId;
        const flags = await this.flagService.runFlagRoutineForAppointment(appointmentId).toPromise();
        const flagsPatient = await this.flagService.runFlagRoutineForPatient(this.data.appointment.PatientId, this.globals.LOCID).toPromise();
        res.dataAppoitmentFlags = flags;
        res.dataPatientFlags = flagsPatient;
        this.isLoading = false;
        this.dialogRef.close(res);
    }

    async handleReferralRequest(res: DataAppointmentModel) {
        const selectedRef = new ReferralDataModel();
        // Populate selectedRef properties
        selectedRef.ReferralID = this.globals.ReferralAppointmentRequest.ReferralId;
        selectedRef.AppointmentID = res.AppointmentId;
        selectedRef.enumReferralStatusID = EnumReferralStatus.Appointment;
        selectedRef.Notes = this.globals.ReferralAppointmentRequest.Notes;
        await this.referralService.saveDataReferralFrontDesk(selectedRef).toPromise();
        await this.handleReferralImages(selectedRef, res);
        await this.handleReferralAppointmentNote(res);
        this.isReferralRequest = false;
        this.globals.ReferralAppointmentRequest = null;
    }

    async handleWaitList(res: DataAppointmentModel) {
        const waitList = new DataAppointmentWaitListModel();
        waitList.isHandeled = false;
        waitList.Description = this.WaitListReason;
        waitList.AppointmentId = res.AppointmentId;
        await this.schedulingService.saveWaitListAppointment(waitList).toPromise();

    }

    async handleReferralImages(selectedRef: ReferralDataModel, res: DataAppointmentModel) {
        const referralImages = await this.fileService.handledReferralPatientImages({
            ReferralID: selectedRef.ReferralID,
            PatientCaseID: res.PatientCaseId,
            PatientID: res.PatientId
        }).toPromise();
    }

    async handleAppointmentNote(res: DataAppointmentModel) {
        if (this.simpleNote?.note?.Note && this.simpleNote?.note?.Note?.length > 0) {
            await this.simpleNote.saveAppointmentNote(
                res.PatientCaseId,
                res.CaseProcedureId,
                res.AppointmentId
            );
        }
    }

    async handleReferralAppointmentNote(res: DataAppointmentModel) {
        if (this.referralNote?.text && this.referralNote?.text?.length > 0) {
            this.referralNote.patientId = res.PatientId;

            const assoc = new TdoNoteAssociatedObject();
            assoc.objectId = res.PatientCaseId;
            assoc.parentObjectName = 'dataPatientCase';
            this.referralNote.associatedObjects = [];
            this.referralNote.associatedObjects.push(assoc);
            this.referralNote.categoryEnumIds = [NoteCategoryEnum.ReferringDoctorCommunication];
            this.referralNote.typeEnumIds = [NoteTypeEnum.Patient];
            this.notesService.saveNote(this.referralNote).subscribe((res) => {
                this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
            });
        }
    }

    handleSaveAppointmentError(error: any) {
        console.error('Error Saving Appointment Data:', error);
        this.snackBar.open('Error Saving Appointment Data: ' + error.error?.ExceptionMessage, 'Error', {
            duration: 10000,
            verticalPosition: 'top'
        });
    }


    onCancelClick() {
        this.dialogRef.close(null);
    }

    onReferringDoctorChange(event: TdoDropdownChange) {
        const doc = event.value as DoctorDataModel;
        let ref = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
        if (!ref && doc) {
            ref = new AppointmentDetailDataModel();
            ref.DetailParameterName = 'Referring_DoctorId';
            ref.DetailParameterValue = doc.DoctorId;
            ref.AppointmentId = this.data.appointment.AppointmentId;
            this.data.appointment.dataAppoitmentDetails.push(ref);
        } else {
            if (doc) {
                ref.DetailParameterValue = doc.DoctorId;
            }
        }
    }

    onProcedureClick() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.data;
        this.dialog.open(AppointmentProcedureDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {

            }
        });
    }

    getProcedureName() {
        if (this.data.appointment.CaseProcedureId) {
            const proc = this.data.procedures.find(p => p.CaseProcedureId.toLowerCase() === this.data.appointment?.CaseProcedureId?.toLowerCase());
            if (proc) {
                return proc.ProcedureName;
            }
        }
        return '';
    }

    getDoctor() {
        const foundDoctor = this.doctors.find(doctor => doctor?.DoctorId?.toLowerCase() === this.data.appointment?.Label_DoctorId?.toLowerCase());
        if (foundDoctor) {
            // this.triggerChangeDetection();
            return foundDoctor;
        }
        return null;
    }

    onDoctorChange(event: TdoDropdownChange) {
        const doc = event.value;
        if (doc) {
            this.data.appointment.Label_DoctorId = doc.DoctorId;
        }
    }

    onAllDoctorsChange(event: MatCheckboxChange) {
        this.isAllDoctors = event.checked;
        if (this.isAllDoctors) {
            this.doctors = this.data.allDoctors.filter(
                p => p.enumDoctorTypeID?.toLowerCase() === DoctorTypeEnum.PROVIDER.toLowerCase()
            );
        } else {
            this.doctors = this.locationDoctors;
        }
        this.changeDetectorRef.detectChanges();
    }

    getOperatory() {
        const op = this.data.operatories.find(p => p.OperatoryId?.toLowerCase() === this.data.appointment?.Resource_OperatoryId?.toLowerCase());
        if (op) {
            return op;
        }
        return null;
    }

    onOperatoryChange(event: TdoDropdownChange) {
        const op = event.value as OperatoryDataModel;
        this.data.appointment.Resource_OperatoryId = op.OperatoryId;
    }

    getDate(d: Date | string) {
        // console.log('date changed to: ', d)
        return new Date(d);
    }

    onAppointmentDateChange(event: Date) {
        // Create a new Date object by combining date and time components
        const combinedDateTime = this.getCombineDateTime(new Date(event), new Date(this.originalStartDate), true); // new Date(year, month, day + 1, hours, minutes, seconds);
        const combinedDateTimeEnd = this.getCombineDateTime(new Date(event), new Date(this.data.appointment.EndDate), true); // new Date(year, month, day + 1, hoursEnd, minutesEnd, secondsEnd);

        this.data.appointment.StartDate = formatDate(combinedDateTime, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
        this.data.appointment.EndDate = formatDate(combinedDateTimeEnd, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    }

    getCombineDateTime(dateObject: Date, timeObject: Date, fixDay: boolean) {
        // Extract date components from dateObject
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth();
        const day = fixDay ? dateObject.getDate() + 1 : dateObject.getDate();

        // Extract time components from timeObject
        const hours = timeObject.getHours();
        const minutes = timeObject.getMinutes();
        const seconds = timeObject.getSeconds();

        return new Date(year, month, day, hours, minutes, seconds);

    }



    onStartDateChange(event: Date) {
        // console.log('start date changed to: ', event)
        this.originalStartDate = formatDate(event, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
        this.data.appointment.StartDate = formatDate(this.getCombineDateTime(new Date(this.data.appointment.StartDate), new Date(event), false), 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    }

    onEndDateChange(event: Date) {
        this.data.appointment.EndDate = formatDate(event, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    }

    getPatientFlagImage(flag: PatientFlagDataModel) {
        const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
        if (enu) {
            return enu.IconIDSVG;
        }
    }

    getPatientFlagTooltip(flag: PatientFlagDataModel) {
        const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
        if (enu) {
            return enu.ItemDisplayValue;
        }

        return '';
    }

    checkDetailBool(detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            const detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (detail) {
                return detail.DetailParameterValue === 'true';
            }
        }
    }

    checkDetailValueBool(detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            const detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (detail) {
                return detail.DetailParameterValue != null;
            }
        }
    }

    onDetailChange(event: MatCheckboxChange, detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.DetailParameterName = detailName;
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
            }
        }

    }

    onDetailValueChange(check: boolean, value: string, detailName: string) {

        value = value != '' ? value : null;
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.DetailParameterName = detailName;
                detail.DetailParameterValue = check ? value : null;
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                detail.DetailParameterValue = check ? value : null;
            }
            // console.log(`onDetailValueChange ${detailName} detail` , detail);
        }
    }

    getProcedureType(CaseProcedureId: string) {
        const procedure = this.data.procedures.find(p => p.CaseProcedureId.toLowerCase() === CaseProcedureId?.toLowerCase());
        if (procedure) {
            const enu = this.procedureTypeEnums.find(p => p.ValidValueItemId.toLowerCase() === procedure.enumProcedureTypeID?.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }
        return '';
    }

    getPatientPhoneNumber() {
        if (this.patient) {
            const phoneNums = this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Phone || p.enumCommMethodID === CommMethodEnum.Mobile);
            if (phoneNums.length > 0) {
                const preferred = phoneNums.find(p => p.isPreferred);
                if (preferred) {
                    return preferred.Address;
                } else {
                    return phoneNums[0].Address;
                }
            }
        }

        return '';
    }

    gotoPatientLedger() {

    }

    getAppointmentUser() {
        if (this.data && this.data.users) {
            const user = this.data.users.find(p => p.UserID.toLowerCase() === this.data.appointment.xauditModifiedBy.toLowerCase());
            if (user) {
                return user;
            }
        }
        return null;
    }

    generateSMSMessage() {
        let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'customSms');
        if (!detail) {
            detail = new AppointmentDetailDataModel();
            detail.AppointmentId = this.data.appointment.AppointmentId;
            if (this.isOverrideSms) { // if override Sms, delete original from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'originalSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'customSms';
            } else {// if original Sms, delete override sms from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'customSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'originalSms';
            }
            this.data.appointment.dataAppoitmentDetails.push(detail);
        }

        let patientName = '<<Patient Name>>';
        let appointmentDate = '<<Appointment Date>>';
        let doctorName = '<<Doctor Name>>';

        const startTime = new Date(this.data.appointment.StartDate).toLocaleDateString();
        appointmentDate = startTime;

        if (this.data.appointment.Label_DoctorId) {
            const doctor = this.returnDoctorById(this.data.appointment.Label_DoctorId);
            if (doctor) {
                doctorName = `Dr. ${doctor.dataContact.FirstName} ${doctor.dataContact.LastName}`;
            }
        }

        if (this.patient) {
            patientName = `${this.patient.dataContact.FirstName}`;
            if (this.patient.dataContact.LastName) {
                patientName += ' ' + `${this.patient.dataContact.LastName}`;
            }
        }

        detail.DetailParameterValue = `Hello ${patientName}, your appointment with ${doctorName} has been scheduled for ${appointmentDate}. You can access the Patient Portal here: <<Portal Login URL>> Please check your email for more details. Thank you`;
        this.customSmsMessage = detail.DetailParameterValue;
    }

    onOverrideSmsMessage(event: MatCheckboxChange) {
        this.isOverrideSms = event.checked;
        if (this.isOverrideSms) {
            this.generateSMSMessage();
        }
    }

    onEarlierAppointment(event: MatCheckboxChange) {
        this.isWaitList = event.checked;
        if (!this.isWaitList) {
            this.WaitListReason = '';
            this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');

        }
    }

    onCustomSmsFinished(event: string) {
        // this.customSmsMessage = event;
        const detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'customSms');
        if (detail) {
            detail.DetailParameterValue = this.customSmsMessage = event;
            this.isCustomSmsMessage = true;
        }
    }

    onEarlierAppointmentReason(event: string) {
        this.WaitListReason = event;
        this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');
    }

    validateForm() {
        if (this.isAppointmentCanceled) {
            return false;
        }

        if (this.isReadOnlyAppointment) {
            return true;
        }
        else if (this.showBlockAppt()) {
            return !this.data.appointment.Subject;
        } else {
            return !this.data.appointment.PatientId || (!this.data.appointment.CaseProcedureId && !this.data.appointment.PatientCaseId) || !this.data.appointment.Label_DoctorId;
        }


    }

    getUser(userId: string) {
        const user = this.data.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
        if (user) {
            let ret = user.FirstName;
            if (user.LastName) {
                ret += ' ' + user.LastName;
            }
            return ret;
        }
        return '';
    }

    doCheckCustomSms() {
        const detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'customSms');
        if (detail) {
            this.isOverrideSms = true;
            this.customSmsMessage = detail.DetailParameterValue;
        }
        return detail !== null;
    }

    doCheckEarlierAppReason() {
        if (this.data.appointment.isPastedReschedule === true) {
            this.isWaitList = false;
        }
        else {
            const isAddToWaitList = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'isAddToWaitList');
            if (isAddToWaitList && this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'isAddToWaitList').DetailParameterValue === 'true') {
                const detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'isWaitListReason');
                if (detail) {
                    this.isWaitList = true;
                    this.WaitListReason = detail.DetailParameterValue;
                }
                return detail !== null;
            }
        }
    }

    onSecondOperatoryClosed(event: TdoDropdownChange) {
        if (!event.isUserInput) {
            return;
        }
        const selectedOperatories = event.value as OperatoryDataModel[];
        for (const op of selectedOperatories) {
            const mod = new AppointmentOperatoryDataModel();
            mod.OperatoryId = op.OperatoryId;
            mod.AppointmentId = this.data.appointment.AppointmentId;
            this.data.appointment.dataAppoitmentOperatories.push(mod);
        }
        const ids = selectedOperatories.map(p => p.OperatoryId);
        this.schedulingService.reserveAdditionalOperatories(this.data.appointment.AppointmentId, ids).subscribe((res) => {
            this.data.appointment.dataAppoitmentOperatories = res.dataAppoitmentOperatories.filter(p => !p.xauditDeleted);
        });
    }

    getAdditionalOpsList() {
        return this.data.operatories.filter(p => p?.OperatoryId?.toLowerCase() !== this.data.appointment?.Resource_OperatoryId?.toLowerCase());
    }

    getSecondOperatories() {
        const ids = this.data.appointment?.dataAppoitmentOperatories?.filter(p => !p.isPrimary && p.xauditDeleted !== true).map(p => p.OperatoryId);
        return this.data.operatories.filter(p => ids.includes(p.OperatoryId));
    }

    onSecondaryOperatoryChange(event: TdoDropdownChange) {
        if (!event.isUserInput) {
            return;
        }
        this.data.appointment.dataAppoitmentOperatories = [];
        for (const op of event.value as OperatoryDataModel[]) {
            const mod = new AppointmentOperatoryDataModel();
            mod.OperatoryId = op.OperatoryId;
            mod.AppointmentId = this.data.appointment.AppointmentId;
            this.data.appointment.dataAppoitmentOperatories.push(mod);
        }
    }

    clearReferring() {
        const exists = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
        if (exists) {
            exists.DetailParameterValue = null;
        }
    }

    onCancellationCallTaskChange(vvid: string, taskCheckbox: MatCheckbox, dateTimeControl: HTMLInputElement) {
        taskCheckbox.checked = true;
        const date = new Date();
        let daysToAdd = 0;

        switch (vvid) {
            case NextApptWhenEnum.NONE:
            case NextApptWhenEnum.CONVENIENCE:
            case NextApptWhenEnum.RECALL:
                daysToAdd = 0;
                break;
            case NextApptWhenEnum.ONE_DAY:
                daysToAdd = 1;
                break;
            case NextApptWhenEnum.TWO_DAYS:
                daysToAdd = 2;
                break;
            case NextApptWhenEnum.THREE_DAYS:
                daysToAdd = 3;
                break;
            case NextApptWhenEnum.THIRTY_DAYS:
                daysToAdd = 30;
                break;
            case NextApptWhenEnum.SIXTY_DAYS:
                daysToAdd = 60;
                break;
            case NextApptWhenEnum.NINETY_DAYS:
                daysToAdd = 90;
                break;
            case NextApptWhenEnum.ONE_WEEK:
                daysToAdd = 7;
                break;
            case NextApptWhenEnum.ONE_AND_HALF_WEEKS:
                daysToAdd = 10;
                break;
            case NextApptWhenEnum.TWO_WEEKS:
                daysToAdd = 14;
                break;
            case NextApptWhenEnum.THREE_WEEKS:
                daysToAdd = 21;
                break;
            case NextApptWhenEnum.SIX_WEEKS:
                daysToAdd = 42;
                break;
            case NextApptWhenEnum.SIX_MONTHS:
                daysToAdd = 180;
                break;
        }

        date.setDate(date.getDate() + daysToAdd);
        const str = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en_US');
        dateTimeControl.value = str;
        this.onDetailValueChange(true, str, 'isAddToCallList');
    }

    showBlockAppt() {
        if (this.data.appointment.enumApptTypeId === ApptTypeEnum.BlockOut || this.data.appointment.enumApptTypeId === ApptTypeEnum.BlockIn) {
            return true;
        }
        else {
            return false;
        }
    }

    setStatusIfBlock(ValidValueItemId: string) {
        if (ValidValueItemId === ApptTypeEnum.BlockOut || ValidValueItemId === ApptTypeEnum.BlockIn) {
            this.data.appointment.enumApptStatusId = ApptStatusEnum.Unconfirmed;
        }
    }
}
